import _extends from "@babel/runtime-corejs3/helpers/extends";
import _asyncToGenerator from "@babel/runtime-corejs3/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["title", "message", "confirmText", "cancelText", "onClose", "onCancel", "onConfirm", "destructive"];
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
import _Promise from "@babel/runtime-corejs3/core-js-stable/promise";
import React, { useState } from 'react';
import { useToken } from '@rexlabs/styling';
import { ButtonGroup, OutlineButton, PrimaryButton, DestructiveButton } from '@rexlabs/button';
import { Dialog } from './core';
import { StickyFooter } from '../sticky-footer';
export function ConfirmationDialog(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Are you sure you want to do this?' : _ref$title,
      message = _ref.message,
      _ref$confirmText = _ref.confirmText,
      confirmText = _ref$confirmText === void 0 ? 'Confirm' : _ref$confirmText,
      _ref$cancelText = _ref.cancelText,
      cancelText = _ref$cancelText === void 0 ? 'Cancel' : _ref$cancelText,
      onClose = _ref.onClose,
      onCancel = _ref.onCancel,
      onConfirm = _ref.onConfirm,
      destructive = _ref.destructive,
      props = _objectWithoutProperties(_ref, _excluded);

  var token = useToken();
  var ConfirmButton = token('dialog.confirmation.confirmButton.component', destructive ? DestructiveButton : PrimaryButton);
  var CancelButton = token('dialog.confirmation.cancelButton.component', OutlineButton);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      cancelLoading = _useState2[0],
      setCancelLoading = _useState2[1];

  function handleCancel(_x) {
    return _handleCancel.apply(this, arguments);
  }

  function _handleCancel() {
    _handleCancel = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              setCancelLoading(true);
              _context.next = 3;
              return _Promise.resolve(onCancel === null || onCancel === void 0 ? void 0 : onCancel(e));

            case 3:
              if (!e.defaultPrevented) {
                onClose === null || onClose === void 0 ? void 0 : onClose(e);
              } else {
                setCancelLoading(false);
              }

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _handleCancel.apply(this, arguments);
  }

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      confirmLoading = _useState4[0],
      setConfirmLoading = _useState4[1];

  function handleConfirm(_x2) {
    return _handleConfirm.apply(this, arguments);
  }

  function _handleConfirm() {
    _handleConfirm = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(e) {
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setConfirmLoading(true);
              _context2.next = 3;
              return _Promise.resolve(onConfirm === null || onConfirm === void 0 ? void 0 : onConfirm(e));

            case 3:
              if (!e.defaultPrevented) {
                onClose === null || onClose === void 0 ? void 0 : onClose(e);
              } else {
                setConfirmLoading(false);
              }

            case 4:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return _handleConfirm.apply(this, arguments);
  }

  return /*#__PURE__*/React.createElement(Dialog, _extends({
    intent: "alert",
    title: title
  }, props), message, /*#__PURE__*/React.createElement(StickyFooter, null, /*#__PURE__*/React.createElement(ButtonGroup, {
    end: true
  }, /*#__PURE__*/React.createElement(CancelButton, {
    onClick: handleCancel,
    isLoading: cancelLoading
  }, cancelText), /*#__PURE__*/React.createElement(ConfirmButton, {
    type: "submit",
    onClick: handleConfirm,
    isLoading: confirmLoading
  }, confirmText))));
}